import { sortByKey } from './sortByKey';

export const filterDuplicateObjects = <T, K extends keyof T>(
  array: T[],
  key: K
): T[] => {
  const seen = new Set<T[K]>();
  const filtredArray = array.filter((item) => {
    const value = item[key];
    if (seen.has(value)) {
      return false;
    }
    seen.add(value);
    return true;
  });

  return sortByKey(filtredArray, key, true);
};
